import React, { FC } from 'react'
import { ButtonProps } from './ButtonProps'
import { ReactComponent as Loader } from '../../../../../media/svg/loader.svg'
import './styleButton.css';

const Button: FC<ButtonProps> = ({ onSubmit, text, loading, disabled, className }) => {
    const styleClass: string = `${className}`
    
    return (
      <button id='submit' className={styleClass} onSubmit={onSubmit} disabled={disabled} >
        {!loading ? text : <Loader className="spinner" />}
      </button>
    )
  }
  
  export default Button